module.exports = __webpack_public_path__ + "img/ball-triangle.bc2bfd39.svg";